import React, { Component } from 'react'
import {Toast} from 'antd-mobile';
import tools from '@/utils/tool';
import API from './../../config/api';
import httpRequest from '@/utils/httpRequest'
import './index.scss'
import Header from '@/components/Header/header'

export default class index extends Component {
  constructor(props){
    super(props)
    this.state = {
      type:'', // 1: 实践街道详情  其他：实践基础详情
      uuid:'',
      data:{},
    }
  }

  componentDidMount(){
    let url = window.location.href
    let parameter =  tools.getParams(url)
    this.setState({
      type:parameter.type,
      uuid:parameter.uuid
    },() => {
      this.getList()
    })
  }

  getList = () => {
    const {type,uuid} = this.state
    let url = ''
    let data = {}
    if(type / 1 === 1){
      url = API.practiceStreetDetail
      data.street_id = uuid 
    } else{
      url = API.practiceBaseDetail
      data.base_id = uuid 
    }
    httpRequest({
      url: url,
      type: 'get',
      data: data
    }).done((resp) => {
      if (resp.code === 0) {
        this.setState({
          data:resp.data
        })
      } else {
        Toast.fail(resp.msg || resp.error);
      }
    }).fail(jqXHR => {
      Toast.fail(jqXHR.msg || jqXHR.error);
    })
  }

  clickPracticeStation = (data) => {
    this.props.history.push(`/civilizationPraStationDetail?uuid=${data.uuid}`)
  }

  judgeTitle = (data) => {
    const {type} = this.state
    let title = ''
    if(type / 1 === 1){
      title = data.street_title
    } else if(type / 1 === 2){
      title = data.base_title
    } else {
      title = data.title
    }
    return title
  }

  render() {
    const {data,type} = this.state
    return (
      <div>
        {/*头部*/}
			  <Header name={'home'} uuid={''}/>
        <div className='container'>
          <div className="title">{this.judgeTitle(data)}</div>
          <div dangerouslySetInnerHTML={{
                __html: type / 1 === 1 ? data.street_info : data.info
          }}/>
          {data.practice_place_list && data.practice_place_list.length > 0 ?
            <div className="practiceStation">
              <div className="title">实践站</div>          
              {data.practice_place_list.map((item,index) => {
                return <div className='module' key={index} onClick={this.clickPracticeStation.bind(this,item)}>
                          <div className='imgBox'></div>
                          <div className="name limit-line2">{item.title}</div>
                        </div>
              })}
            </div>
          :''}
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/CivilizationListDetail/index.js